import { PlusIcon } from "@heroicons/react/20/solid";
import NoItemsRow from "@/common/NoItemsRow";
import { useState } from "react";
import { connect } from "react-redux";
import ReportPackModal from "./ReportPackModal";
import { useEffect } from "react";
import ReportPackRow from "./ReportPackRow";
import { Actions as REPORTACTIONS } from "../../../store/actions/reportActions";

const ReportPacks = ({ reportPacks, saveReportPacks }) => {
	return (
		<form style={{ paddingBottom: 30 }}>
			<div className="form-section col-xs-12">
				<div className="col-xs-12">
					<div className="pull-left">
						<h4>Report Packs</h4>
					</div>
					<ReportPackModal reportPacks={reportPacks} />
				</div>
				<div className="clearfix" />

				<div className="col-xs-12 pl-0 pb-6">
					 <table className="js-table-sections table table-hover">
						{/*<Pagination />*/}
						<thead style={{ display: "table-header-group" }}>
							<tr>
								<th>
									Name
								</th>
								<th>
									# Organisations
								</th>
								<th>
									# Reports
								</th>
								<th className="text-right">
									Actions
								</th>
							</tr>
						</thead>
						<tbody>
							 {reportPacks?.length ? (
								<>
									{reportPacks?.map((reportPack) => {
										const deletePack = () => {
											const newReportPacks = [...reportPacks];

											const reportIndex = newReportPacks?.findIndex((pack) => pack.id === reportPack?.id);
											newReportPacks.splice(reportIndex, 1);

											saveReportPacks(newReportPacks);
										};
										return (
											<ReportPackRow
												key={reportPack?.id}
												reportPack={reportPack}
												deletePack={deletePack}
											/>
										);
									})}
								</>
							) : <tr>
							 </tr>
						}
						</tbody>
					 </table>

				</div>
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	return {
		reportPacks: state.advisors?.reports?.reportPacks || [],
	};
};

const mapDispatchToProps = (dispatch) => ({
	saveReportPacks: (data) => dispatch(REPORTACTIONS.postReportPacks(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPacks);
